import { getStatusSales } from '../../constants/kickavenue';
import { isReturnRelisted, readSaleReturn } from '../Returns/returnSale';

const returnLabels = {
  OUTSTANDING: 'Outstanding',
  QC: 'Quality Control',
  LC: 'Legit Check',
  FOLLOW_UP: 'Follow Up',
  APPROVED: 'Return Approved',
  RELISTING: 'Need Relisting',
  NEED_REFUND: 'Need Return Refund',
  PRE_DELIVERING: 'Pre Delivering',
  DELIVERING: 'Delivering',
  PROCESSED: 'Processed Return',
  DONE: 'Processed Return',
  REJECTED: 'Rejected Returns',
};

export const saleReturnStatus = (sale, existingLabel) => {
  const status = sale.status;
  const translated = getStatusSales(status);
  const base = existingLabel || (/^DONE(?:_|$)/.test(status || '') ? 'Done' : translated === 'Undefined' ? status || '-' : translated);
  const { record } = readSaleReturn(sale);
  if (!record) return base;
  if (isReturnRelisted(sale)) return `${base} — Relisted`;
  if (!record.status) return base;
  return `${base} — Return: ${returnLabels[record.status] || record.status}`;
};
